"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAffiliateCookie = exports.AFFILIATE_COOKIE_NAME = exports.basketCookieHeader = exports.removeBasketCookie = exports.getBasketCookie = exports.setBasketCookie = exports.removeOrderReferenceCookie = exports.getOrderReferenceCookie = exports.setOrderReferenceCookie = exports.checkoutCookieHeader = exports.checkoutCookieOptions = exports.BASKET_COOKIE_NAME = exports.ORDER_REFERENCE_COOKIE_NAME = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
exports.ORDER_REFERENCE_COOKIE_NAME = 'orderReference';
exports.BASKET_COOKIE_NAME = 'basketId';
// A browser refuses a SameSite=Lax cookie in the cross-site frame a partner site uses, so these
// use CHIPS. Partitioned and SameSite=None both need Secure, which local http cannot offer.
const checkoutCookieOptions = ({ isSecure, }) => ({
    path: '/',
    secure: isSecure,
    sameSite: isSecure ? 'none' : 'lax',
    partitioned: isSecure,
});
exports.checkoutCookieOptions = checkoutCookieOptions;
const isSecureContext = process.env.NODE_ENV === 'production';
const cookieOptions = (0, exports.checkoutCookieOptions)({ isSecure: isSecureContext });
// js-cookie writes document.cookie, so a server response needs its own serialiser.
const checkoutCookieHeader = ({ name, value, isSecure, }) => {
    const options = (0, exports.checkoutCookieOptions)({ isSecure });
    const parts = [`${name}=${value}`, `Path=${options.path}`];
    if (options.secure) {
        parts.push('Secure');
    }
    parts.push(options.sameSite === 'none' ? 'SameSite=None' : 'SameSite=Lax');
    if (options.partitioned) {
        parts.push('Partitioned');
    }
    return parts.join('; ');
};
exports.checkoutCookieHeader = checkoutCookieHeader;
// A pre-CHIPS unpartitioned cookie of the same name shadows the partitioned one: the browser
// keeps both and Cookie.get returns the legacy one first, so a plain Cookie.set never wins and a
// remove keyed on the partitioned attributes leaves it behind. Clear both variants on every write
// and delete so the value just written is the only one the reader can see.
const legacyCookieOptions = { path: '/' };
const setCheckoutCookie = (name, value) => {
    js_cookie_1.default.remove(name, legacyCookieOptions);
    js_cookie_1.default.remove(name, cookieOptions);
    js_cookie_1.default.set(name, value, cookieOptions);
};
const removeCheckoutCookie = (name) => {
    js_cookie_1.default.remove(name, legacyCookieOptions);
    js_cookie_1.default.remove(name, cookieOptions);
};
const setOrderReferenceCookie = (orderReference) => setCheckoutCookie(exports.ORDER_REFERENCE_COOKIE_NAME, orderReference);
exports.setOrderReferenceCookie = setOrderReferenceCookie;
const getOrderReferenceCookie = () => {
    return js_cookie_1.default.get(exports.ORDER_REFERENCE_COOKIE_NAME);
};
exports.getOrderReferenceCookie = getOrderReferenceCookie;
const removeOrderReferenceCookie = () => removeCheckoutCookie(exports.ORDER_REFERENCE_COOKIE_NAME);
exports.removeOrderReferenceCookie = removeOrderReferenceCookie;
const setBasketCookie = (basketId) => setCheckoutCookie(exports.BASKET_COOKIE_NAME, basketId);
exports.setBasketCookie = setBasketCookie;
const getBasketCookie = () => {
    return js_cookie_1.default.get(exports.BASKET_COOKIE_NAME);
};
exports.getBasketCookie = getBasketCookie;
const removeBasketCookie = () => removeCheckoutCookie(exports.BASKET_COOKIE_NAME);
exports.removeBasketCookie = removeBasketCookie;
const basketCookieHeader = (basketId) => (0, exports.checkoutCookieHeader)({
    name: exports.BASKET_COOKIE_NAME,
    value: basketId,
    isSecure: isSecureContext,
});
exports.basketCookieHeader = basketCookieHeader;
exports.AFFILIATE_COOKIE_NAME = 'affiliate';
const getAffiliateCookie = () => {
    return js_cookie_1.default.get(exports.AFFILIATE_COOKIE_NAME);
};
exports.getAffiliateCookie = getAffiliateCookie;
